import { useService } from '../redux/reducer/service';
import useServiceData from './useServiceData';
import { useUser } from '../redux/reducer/user';
import { useMemo } from 'react';

export const useMarkButtons = ({ buttons, dependencies, availableNavigation, prefixNavigation }) => {
  const { serviceData: serviceDataInfo } = useService();
  const { save } = useServiceData();
  const { profile } = useUser();

  const saveMarkData = (data) => save('marksNew', data);

  return useMemo(() => {
    if (dependencies.some((dependency) => !dependency) || !profile) return buttons;

    const serviceData = serviceDataInfo?.['marksNew'];

    return buttons.map((button) => {
      if (!button.type) return button;

      const { type } = button;
      const prefixCallback = prefixNavigation[type];
      const availableValue = availableNavigation[type];
      const currentKey = prefixCallback(availableValue);
      const prevKey = serviceData?.hasOwnProperty(currentKey);
      const splitKey = Object.keys(serviceData ?? {})
        .find((key) => key.startsWith(type))
        ?.split('Mark');

      if (prevKey) return button;

      const extraCallback = () => {
        const newServiceData = { [currentKey]: true };

        if (!serviceData) {
          saveMarkData(newServiceData);
          return;
        }

        for (const key in serviceData) {
          if (key.startsWith(`${type}Mark`)) continue;
          newServiceData[key] = serviceData[key];
        }

        saveMarkData(newServiceData);
      };

      if (availableValue < Number(splitKey?.[splitKey?.length - 1])) {
        extraCallback();
        return button;
      }

      return { ...button, extraCallback };
    });
  }, [profile, serviceDataInfo, ...dependencies]);
};
